<div class="flex flex-col md:inline-flex md:flex-row select-none items-start md:items-center gap-2 md:gap-2 px-0 md:px-3 py-0 md:py-1.5 md:bg-white md:border md:border-grey-200 md:rounded-lg w-full md:w-auto">
  <!-- Icon -->
  <div class="flex items-center gap-2 w-full md:w-auto">
    @if (isPrimeIcon()) {
      <i [class]="'pi ' + icon + ' text-lg md:text-sm text-primary-600'"></i>
    } @else {
      <span class="text-lg md:text-sm leading-none">{{ icon }}</span>
    }
    
    <!-- Label on mobile only -->
    <span class="text-sm md:hidden font-semibold text-grey-600 uppercase tracking-wide">{{ label }}</span>
  </div>

  <!-- Content -->
  <div class="flex flex-col md:flex-row items-start md:items-center gap-1 md:gap-1.5 w-full md:w-auto pl-8 md:pl-0">
    <!-- Label on desktop only -->
    <span class="hidden md:inline text-[0.7rem] font-semibold text-grey-500 uppercase tracking-wide">{{ label }}</span>
    <span class="hidden md:inline text-grey-300">·</span>
    
    @if (showTag) {
      @if (isClickable && getDisplayParts().plusIndicator) {
        <div class="flex items-center gap-1.5">
          <span 
            class="text-base md:text-xs font-semibold px-2 md:px-1.5 py-1 md:py-0.5 rounded w-full md:w-auto text-left text-grey-900"
            [ngClass]="{
              'md:border md:border-primary-100 md:bg-primary-50 md:text-primary-950': type === 'focus',
              'md:border md:border-orange-100 md:bg-orange-50 md:text-orange-950': type === 'pain',
              'md:bg-grey-100 md:text-grey-700': type === 'default'
            }">
            {{ getDisplayParts().mainText }}
          </span>
          <span 
            class="text-xs font-bold px-2 py-1 rounded-full transition-all duration-200 cursor-pointer select-none"
            [ngClass]="{
              'bg-primary-500 text-white hover:bg-primary-600 active:bg-primary-700': type === 'focus',
              'bg-orange-200 border-2 border-orange-100 text-orange-950 hover:bg-orange-200 active:bg-orange-300': type === 'pain',
              'bg-grey-500 text-white hover:bg-grey-600 active:bg-grey-700': type === 'default'
            }">
            {{ getDisplayParts().plusIndicator }}
          </span>
        </div>
      } @else {
        <span 
          class="text-base md:text-xs font-semibold px-2 md:px-1.5 py-1 md:py-0.5 rounded w-full md:w-auto text-left text-grey-900"
          [ngClass]="{
            'md:border md:border-primary-100 md:bg-primary-50 md:text-primary-950': type === 'focus',
            'md:border md:border-orange-100 md:bg-orange-50 md:text-orange-950': type === 'pain',
            'md:bg-grey-100 md:text-grey-700': type === 'default'
          }">
          {{ value }}
        </span>
      }
    } @else {
      <span class="text-base md:text-xs font-semibold text-grey-900">{{ value }}</span>
    }
  </div>
</div>
